import React, { ReactNode } from "react";

type ConditionalWrapperProps = {
  condition: boolean;
  wrapper: (children: ReactNode) => JSX.Element;
  children: ReactNode;
};

const ConditionalWrapper = ({
  condition,
  wrapper,
  children,
}: ConditionalWrapperProps): JSX.Element => {
  return condition ? wrapper(children) : <>{children}</>;
};

export default ConditionalWrapper;